import { TooltipModel, TooltipModelProps } from '@mail/3promo/models/tooltip';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { SafetyLocalStorage } from '@mail-core/std';
import { xray } from 'lib/xray';
import { IS_PHONE_BROWSER, USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { familyFreemiumFeaturesTooltip } from 'reactApp/appHelpers/featuresHelpers/features/freemium';
import {
    FamilyFreemiumFeaturesTooltip,
    getTooltipAnalyticsName,
} from 'reactApp/ui/FamilyFreemiumFeaturesTooltip/FamilyFreemiumFeaturesTooltip';
import { sendDwh } from 'reactApp/utils/ga';

const TOOLTIP_CLOSED_KEY = 'family_freemium_features_tooltip_closed';

const TOOLTIP_KEY = 'family-freemium-features-tooltip';

export const FamilyFreemiumFeaturesTooltipCreator: ModelCreator = ({ models, render, stores }) => {
    const email = USER_EMAIL;
    const lStorage = new SafetyLocalStorage({});
    const tooltipAnalyticsName = getTooltipAnalyticsName();

    const selector = '[data-qa-id="family-freemium-features"]';

    return new TooltipModel(
        TOOLTIP_KEY,
        models.base,
        new TooltipModelProps(TOOLTIP_KEY, {
            store: new LocalStorageStore(TOOLTIP_KEY, stores.localStorage),
            renderer: new ReactRenderer(TOOLTIP_KEY, FamilyFreemiumFeaturesTooltip as any, render.react),
            closable: true,
            hideOnOutsideClick: true,
            isModelEnabledCheck: () => true,
            ignoreTestOnRedraw: true,
            test: (resolve, reject) => {
                if (!familyFreemiumFeaturesTooltip) {
                    reject();
                    return;
                }
                if (IS_PHONE_BROWSER) {
                    reject();
                    return;
                }
                const target = document.querySelector(selector) as HTMLElement;
                if (!target) {
                    reject();
                    return;
                }
                const closed = lStorage.getItem(`${email}|${TOOLTIP_CLOSED_KEY}`);
                if (closed) {
                    reject();
                    return;
                }
                const emptyState = document.querySelector('[data-qa-id="family-empty"]');
                if (emptyState) {
                    reject();
                    return;
                }
                resolve();
            },
            templateData: {
                title: 'Тут можно посмотреть, какие возможности есть у подписки',
                text: 'И протестировать всё, пока действует пробный период',
                targetSelector: selector,
                placement: 'top-end',
                leftOffset: 0,
                onCrossClose: () => {
                    xray.send('family-freemium-features-tooltip-cross');
                },
                onClick: () => {
                    lStorage.setItem(`${email}|${TOOLTIP_CLOSED_KEY}`, 'true');
                    xray.send('family-freemium-features-tooltip-click');
                },
            },
            getTarget: () => {
                return document.querySelector(selector) as HTMLElement;
            },
            onShow: () => {
                xray.send('family-freemium-features-tooltip-show');
                sendDwh({
                    eventCategory: 'tooltip',
                    action: 'show',
                    dwh_enabled: true,
                    dwhData: {
                        name: tooltipAnalyticsName,
                    },
                });
            },
            onClose: () => {
                xray.send('family-freemium-features-tooltip-close');
            },
        })
    );
};
